import * as z from "zod/v4";
import { streamChannelNameSchema } from "./registry";

// Re-export input schemas so existing imports from "./session" still work
export {
  teamNotificationsStreamInputSchema,
  type TeamNotificationsStreamInput,
  userNotificationsStreamInputSchema,
  type UserNotificationsStreamInput,
} from "./definitions";

export const streamSessionIdSchema = z.string();
export type StreamSessionId = z.infer<typeof streamSessionIdSchema>;

export const streamSubscriptionKeySchema = z.string();
export type StreamSubscriptionKey = z.infer<typeof streamSubscriptionKeySchema>;

export const streamSessionPathSchema = z.object({
  sessionId: streamSessionIdSchema,
});
export type StreamSessionPath = z.infer<typeof streamSessionPathSchema>;

export const openStreamSessionResponseSchema = z.object({
  sessionId: streamSessionIdSchema,
});
export type OpenStreamSessionResponse = z.infer<
  typeof openStreamSessionResponseSchema
>;

export const streamControlSuccessSchema = z.object({
  success: z.literal(true),
});
export type StreamControlSuccess = z.infer<typeof streamControlSuccessSchema>;

export const streamSubscribeControlInputSchema = z.object({
  action: z.literal("subscribe"),
  channel: streamChannelNameSchema,
  input: z.unknown().optional(),
  subscriptionKey: streamSubscriptionKeySchema,
});
export type StreamSubscribeControlInput = z.infer<
  typeof streamSubscribeControlInputSchema
>;

export const streamUnsubscribeControlInputSchema = z.object({
  action: z.literal("unsubscribe"),
  subscriptionKey: streamSubscriptionKeySchema,
});
export type StreamUnsubscribeControlInput = z.infer<
  typeof streamUnsubscribeControlInputSchema
>;

export const streamControlInputSchema = z.discriminatedUnion("action", [
  streamSubscribeControlInputSchema,
  streamUnsubscribeControlInputSchema,
]);
export type StreamControlInput = z.infer<typeof streamControlInputSchema>;
